module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.fb4190fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/whatsapp-icon.svg
// module id = 1591
// module chunks = 0